export default "__VITE_ASSET__Dysda0Yk__"